import React, { useCallback, useEffect, useState } from "react"
import Slider from "react-slick"
import queryString from "query-string"
import { Backdrop, Fade, Modal } from "@material-ui/core"
import HTMLEllipsis from "react-lines-ellipsis/lib/html"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { ReactComponent as Arrow } from "./images/arrow_schedule.svg"
import { ReactComponent as Close } from "./images/close.svg"

const Prev = ({ onClick, festival }) => (
  <button
    className={`slick-arrow slick-prev ${
      festival ? festival.toLowerCase().replace(/\s/, "-") : ""
    }`}
    onClick={onClick}
  >
    <Arrow />
  </button>
)

const Next = ({ onClick, festival }) => (
  <button
    className={`slick-arrow slick-next ${
      festival ? festival.toLowerCase().replace(/\s/, "-") : ""
    }`}
    onClick={onClick}
  >
    <Arrow />
  </button>
)

const OnDemand = (props) => {
  const {
    buckets,
    filters,
    ordering,
    screenings,
    ticketing,
    path,
    topFestival,
    trackList,
    title,
  } = props

  const [modal, setModal] = useState({
    openedId: null,
    track: null,
    index: null,
  })

  const [dragging, setDragging] = useState(false)
  const [eventTracks, setEventTracks] = useState([])
  const [orderedTracks, setOrderedTracks] = useState([])
  const [sliders, setSliders] = useState({})
  const [bucketJSON, setBucketJSON] = useState([])

  useEffect(() => {
    if (buckets) {
      setBucketJSON(JSON.parse(buckets)["event_buckets"])
    }
  }, [])

  useEffect(() => {
    if (screenings.length && Object.keys(sliders).length) {
      const openedCard = queryString.parse(window.location.search)

      if (openedCard.screening) {
        const cardElement = document.getElementById(
          `screening-${openedCard.screening}`,
        )

        if (cardElement) {
          setModal({
            openedId: openedCard.screening,
            track: openedCard.track,
            index: openedCard.index,
          })
          window.scroll({
            top: document
              .getElementById(`screening-${openedCard.screening}`)
              .getBoundingClientRect().top,
            behavior: "smooth",
          })

          if (sliders[openedCard.track]) {
            sliders[openedCard.track].slickGoTo(openedCard.index)
          }
        }
      }
    }
  }, [screenings, sliders])

  useEffect(() => {
    if (trackList.length) {
      if (!eventTracks.length) {
        const fromEvents = [...trackList]
        setEventTracks(fromEvents)
      }

      const updatedTrackList = [...trackList].concat(eventTracks)

      setOrderedTracks(
        updatedTrackList.sort((a, b) => {
          const aOrder = ordering.find((o) => o.name === a)
          const bOrder = ordering.find((o) => o.name === b)

          if (aOrder && bOrder) {
            return (aOrder.position || 100) > (bOrder.position || 100) ? 1 : -1
          }

          return 2
        }),
      )
    } else {
      setOrderedTracks([title])
    }
  }, [trackList])

  const handleBeforeChange = useCallback(
    (prev, next, sliderId) => {
      setDragging(true)

      const slider = document.querySelector(`#slider-${sliderId} .slick-slider`)

      if (prev === 0) {
        slider.classList.remove("begin")
      }

      if (next === 0) {
        slider.classList.add("begin")
      }

      if (next % 1 > 0) {
        slider.classList.add("end")
      }

      if (next < prev) {
        slider.classList.remove("end")
      }
    },
    [setDragging],
  )

  const handleAfterChange = useCallback(() => {
    setDragging(false)
  }, [setDragging])

  const handleBlockOpen = (block, track, index) => {
    if (!dragging) {
      setModal({
        openedId: block,
        track,
        index,
      })

      window.history.pushState(
        null,
        null,
        `${window.location.origin}${window.location.pathname}?screening=${block}&track=${track}&index=${index}`,
      )
    }
  }

  const handleClose = () => {
    setModal({
      openedId: null,
      track: null,
      index: null,
    })

    window.history.pushState(
      null,
      null,
      `${window.location.origin}${window.location.pathname}`,
    )
  }

  const getBlockBuyLink = (screening) => {
    let foundTicket = ticketing.find((ticket) => {
      if (ticket.film === screening.name) {
        return ticket
      }
    })

    if (foundTicket) {
      // perfect match
      return foundTicket.url
    } else {
      foundTicket = ticketing.filter((ticket) => {
        if (screening.name) {
          // if the ticket name is inside screening name
          if (screening.name.match(new RegExp(ticket.film, "gi"))) {
            return ticket
            // if screening name is inside ticket name
          } else if (ticket.film.match(new RegExp(screening.name, "gi"))) {
            return ticket
            // if it matches after fixing issues with dash types or unnecessary parenthesis
          } else if (
            ticket.film
              .replace("–", "-")
              .replace(/\(+|\)+/gm, "")
              .match(
                new RegExp(
                  screening.name
                    .replace("–", "-")
                    .replace(/\(+|\)+/gm, "")
                    .replace(" - RAD Days", ""),
                  "gi",
                ),
              )
          ) {
            return ticket
            // try matching after removing extra info before or after hyphens
          } else if (
            ticket.film
              .replace(/^(\d+ - )/gm, "")
              .replace(/( - .+)$/gm, "")
              .match(
                new RegExp(
                  screening.name
                    .replace(/^(\d+ - )/gm, "")
                    .replace(/( - .+)$/gm, "")
                    .replace(" - RAD Days", ""),
                ),
              )
          ) {
            return ticket
          } else if (
            ticket.film
              .replace(/^(\d+\w+ - )/gm, "")
              .replace(/( - .+)$/gm, "")
              .match(
                new RegExp(
                  screening.name
                    .replace(/^(\d+\w+ - )/gm, "")
                    .replace(/( - .+)$/gm, "")
                    .replace(" - RAD Days", ""),
                ),
              )
          ) {
            return ticket
          } else if (
            ticket.film.match(
              new RegExp(
                screening.name
                  .replace("–", "-")
                  .replace(" - Virtual", " VIRTUAL")
                  .replace("’", "'")
                  .replace(" - RAD Days", ""),
                "gi",
              ),
            )
          ) {
            return ticket
          } else if (
            ticket.film.match(
              screening.name.replace("–", "-").replace(" - Virtual", ""),
            )
          ) {
            return ticket
          }
        }
      })

      if (foundTicket.length) {
        if (foundTicket.length > 1) {
          const radDays = foundTicket.find((ticket) =>
            ticket.name.toLowerCase().match(/rad days/gm),
          )

          const virtualTicket = foundTicket.find((ticket) =>
            ticket.name.toLowerCase().match(/virtual/gm),
          )

          if (radDays && screening.name.toLowerCase().match(/rad days/gm)) {
            return radDays.url
          } else if (virtualTicket) {
            return virtualTicket.url
          } else {
            foundTicket[0].url
          }
        } else {
          return foundTicket[0].url
        }
      } else if (screening.tickets) {
        return screening.tickets
      }
    }
  }

  const getBlockScreeningLink = (screening) => {
    if (screening.showOnDemand) {
      if (bucketJSON.length) {
        const bucket = bucketJSON.find((b) => b.id === screening.eventBucket)
        if (bucket) {
          const path = bucket.urls.root
            .replace("https://", "")
            .replace(".eventive.org/", "")

          return `https://watch.eventive.org/${path}/play/${screening.screeningId}`
        }
      }
    } else if (path) {
      return `https://watch.eventive.org/${path}/play/${screening.id}`
    }

    return false
  }

  const hasGenre = (item) => {
    if (filters.genre === "") {
      return true
    } else if (typeof item === "string") {
      const events = trackScreenings(item)
      // const trackScreenings = screenings.filter((s) =>
      //   s.tracks.find((t) => t === item),
      // )
      if (events) {
        const filmsList = events.map((screen) => screen.films).flat()
        const foundFilm = filmsList.find((f) =>
          ((f.document || {}).genres || []).includes(filters.genre),
        )
        if (foundFilm) return true
      }
    } else {
      const foundFilm = item.find((f) =>
        ((f.document || {}).genres || []).includes(filters.genre),
      )
      if (foundFilm) return true
    }

    return false
  }

  const trackScreenings = (track) => {
    const foundScreenings = screenings.filter((screen) =>
      screen.tracks.find((tag) => tag === track),
    )

    if (foundScreenings.length) {
      return foundScreenings
    } else if (orderedTracks.length === 1 && orderedTracks[0] === track) {
      return screenings
    } else {
      return []
    }
  }

  const blockCard = (block, index, track) => {
    const films = block.films.filter((f) => f.document)

    if (films.length) {
      return (
        <div key={index} id={`screening-${block.id}`}>
          <div className="film-card-wrapper">
            <button
              className={`film-card`}
              onClick={() => handleBlockOpen(block.id, track, index)}
            >
              {(films[0].still_image || block.featured) && (
                <div className="film-card__image">
                  <img src={block.featured || films[0].still_image} />
                </div>
              )}

              <div className="film-card__details">
                <h3>{block.name || block.title}</h3>
                {films.length > 1 ? (
                  <p>
                    {films.length} film{films.length > 1 && "s"}
                  </p>
                ) : (
                  <p>
                    {(films[0].document.genres || []).length > 0 &&
                      `${films[0].document.genres.join(" / ")} / `}
                    {(films[0].document.languages || []).length > 0 &&
                      `${films[0].document.languages.join(" / ")} / `}
                    {films[0].details.runtime &&
                      `${films[0].details.runtime}${
                        films[0].details.runtime.match(/minutes/)
                          ? ""
                          : films[0].details.runtime.match(/minute/)
                          ? ""
                          : parseInt(
                              films[0].details.runtime.replace(/\D/, ""),
                            ) === 1
                          ? "minute"
                          : " minutes"
                      }`}
                  </p>
                )}
              </div>
            </button>
            <Modal
              open={modal.openedId === block.id}
              onClose={handleClose}
              BackdropComponent={Backdrop}
              closeAfterTransition
            >
              <Fade in={modal.openedId === block.id}>
                <div className="film-modal-wrapper">
                  <div className={`film-modal`}>
                    {(films[0].cover_image || block.featured) && (
                      <div className="film-modal__image">
                        <img src={block.featured || films[0].cover_image} />
                      </div>
                    )}
                    <div className="film-modal__details">
                      <h3>{block.name || block.title}</h3>

                      {films.length > 1 ? (
                        <p>
                          {films.length} film
                          {films.length > 1 && "s"}
                        </p>
                      ) : (
                        <p>
                          {(films[0].document.genres || []).length > 0 &&
                            `${films[0].document.genres.join(" / ")} / `}
                          {(films[0].document.languages || []).length > 0 &&
                            `${films[0].document.languages.join(" / ")} / `}
                          {films[0].details.runtime &&
                            `${films[0].details.runtime}${
                              films[0].details.runtime.match(/minutes/)
                                ? ""
                                : films[0].details.runtime.match(/minute/)
                                ? ""
                                : parseInt(
                                    films[0].details.runtime.replace(/\D/, ""),
                                  ) === 1
                                ? "minute"
                                : " minutes"
                            }`}
                        </p>
                      )}
                      {films.length > 1 ? (
                        <>
                          {block.event_url && (
                            <a href={block.event_url}>Learn More</a>
                          )}
                          <div className="film-block">
                            {films
                              .sort((a, b) => {
                                if (
                                  a.name.replace(/\W|\d/g, "") ===
                                  b.name.replace(/\W|\d/g, "")
                                ) {
                                  return (
                                    parseInt(a.name.replace(/\D/g, "")) -
                                    parseInt(b.name.replace(/\D/g, ""))
                                  )
                                }
                                return a.name > b.name ? 1 : -1
                              })
                              .map((film, index) => (
                                <React.Fragment key={index}>
                                  {film.document && (
                                    <a
                                      className="film-card"
                                      key={index}
                                      href={`/films/${film.document.slug}`}
                                    >
                                      {film.still_image && (
                                        <div className="film-card__image">
                                          <img src={film.still_image} />
                                          {film.exclusive && (
                                            <div className="exclusive">
                                              <h4>Exclusive</h4>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      <div className="film-card__details">
                                        <h3>{film.name}</h3>
                                        <p>
                                          {(film.document.genres || []).length >
                                            0 &&
                                            `${film.document.genres.join(
                                              " / ",
                                            )} / `}
                                          {(film.document.languages || [])
                                            .length > 0 &&
                                            `${film.document.languages.join(
                                              " / ",
                                            )} / `}
                                          {film.details.runtime &&
                                            `${film.details.runtime}${
                                              film.details.runtime.match(
                                                /minutes/,
                                              )
                                                ? ""
                                                : film.details.runtime.match(
                                                    /minute/,
                                                  )
                                                ? ""
                                                : parseInt(
                                                    film.details.runtime.replace(
                                                      /\D/,
                                                      "",
                                                    ),
                                                  ) === 1
                                                ? "minute"
                                                : " minutes"
                                            }`}
                                        </p>
                                      </div>
                                    </a>
                                  )}
                                </React.Fragment>
                              ))}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="film-modal__description">
                            <HTMLEllipsis
                              maxLine={6}
                              unsafeHTML={films[0].description}
                            />
                          </div>
                          <a href={`/films/${films[0].document.slug}`}>
                            Learn More
                          </a>
                        </>
                      )}
                      <div className="film-modal__buttons">
                        {getBlockBuyLink(block) && (
                          <a
                            href={getBlockBuyLink(block)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="button"
                          >
                            Buy
                          </a>
                        )}
                        {getBlockScreeningLink(block) && (
                          <a
                            href={getBlockScreeningLink(block)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            I already have a pass
                          </a>
                        )}
                      </div>
                    </div>
                    <button
                      className="film-modal__close"
                      aria-label="close details"
                      onClick={handleClose}
                    >
                      <Close />
                    </button>
                  </div>
                </div>
              </Fade>
            </Modal>
          </div>
        </div>
      )
    }
  }

  const params = {
    infinite: false,
    slidesToShow: 4.5,
    slidesToScroll: 4,
    nextArrow: <Next festival={topFestival} />,
    prevArrow: <Prev festival={topFestival} />,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <div className="on-demand">
      {orderedTracks.length > 0 &&
        orderedTracks.map((track, index) => (
          <React.Fragment key={index}>
            {(filters.track === "all" || filters.track === track) &&
              hasGenre(track) && (
                <div className="on-demand__track">
                  <h2>{track}</h2>

                  <div
                    id={`slider-${track.replace(/\W+/g, "-")}`}
                    className="on-demand__films"
                  >
                    <Slider
                      className="begin"
                      {...params}
                      onInit={() => {
                        setTimeout(() => {
                          setDragging(false)
                        }, 100)
                      }}
                      beforeChange={(prev, next) =>
                        handleBeforeChange(
                          prev,
                          next,
                          track.replace(/\W+/g, "-"),
                        )
                      }
                      afterChange={handleAfterChange}
                      ref={(slider) => {
                        if (slider && !sliders.hasOwnProperty(track)) {
                          setSliders({ ...sliders, [track]: slider })
                        }
                      }}
                    >
                      {trackScreenings(track)
                        .sort((a, b) => {
                          if (!a.name) a.name = a.title
                          if (!b.name) b.name = b.title

                          if (
                            a.name.replace(/\W|\d/g, "") ===
                            b.name.replace(/\W|\d/g, "")
                          ) {
                            return (
                              parseInt(a.name.replace(/\D/g, "")) -
                              parseInt(b.name.replace(/\D/g, ""))
                            )
                          }
                          return a.name > b.name ? 1 : -1
                        })
                        .filter((screening) => {
                          return screening.visibility !== "hidden"
                        })
                        .map((screening, index) => {
                          if (
                            filters.genre === "" ||
                            hasGenre(screening.films)
                          ) {
                            return blockCard(screening, index, track)
                          }
                        })}
                    </Slider>
                  </div>
                </div>
              )}
          </React.Fragment>
        ))}
    </div>
  )
}

export default OnDemand
